

export const API_URL = process.env.REACT_APP_API_URL;
export const MAP_KEY:any = process.env.REACT_APP_GOOGLE_MAP_KEY;
export const STORAGE = "arrow-cmms"
export const KEYS = {
    AUTH_ACCESS: "arrow-auth-access",
    AUTH_REFRESH: "arrow-auth-refresh",

    EDIT_PANELS: {
        PICK_DESIGN: 'pick-design',
        CHANGE_COLOR: 'change-color',
        ADD_TEXT: 'add-text',
        JERSEY_NUMBER: 'jersey-number',
        ADD_IMAGE: 'add-image',
        ROSTER: 'roster',
        QUANTITY_AND_SIZE: 'quantity-and-size',
        READY_TO_GO: 'ready-to-go',
    }
}

export const URLS = {
    AUTH: {
        LOGIN: '/login',
        REGISTER: '/register',
        FORGOT_PASSWORD: '/forgot-password',
        RESET_PASSWORD: '/reset-password/:email',
    },
    HOME: '/',
    PROFILE: '/profile',
    RM_OVERVIEW: '/rm-overview',
    FACILITIES: '/facilities',
    ASSETS: '/assets',
    ASSETS_DETAILS: (id: string = '') => {
        return (id === '') ? `/assets/:id` : `/assets/${id}`
    },
    WARRANTIES: '/warranties',
    LEASE_ASSETS: '/lease-assets',
    DEPRECIATION: '/depreciation',
    MAINTENANCE_CALENDER: '/maintenance-calender',
    WORK_ORDERS: '/work-orders',
    CHECKLISTS: '/checklists',
    INVENTORY: {
        CYCLE_COUNT: '/inventory/cycle-count',
        RECEIVE_STOCK: '/inventory/receive-stock',
        STOCK_PICKING: '/inventory/stock-picking',
        STOCK_ADJUSTMENT: '/inventory/stock-adjustment',

        SPEAR_PARTS: {
            LIST: '/inventory/spear-parts',
            DETAILS: (id: string = '') => {
                return (id === '') ? `/inventory/spear-parts/:id` : `/inventory/spear-parts/${id}`
            }
        },
    },
    PURCHASING: {
        REQUEST: '/purchase/request',
        ORDER: '/purchase/order',
        STOCK: '/purchase/stock',
    },
    VENDORS: '/vendors',
    USERS: '/users',
    REPORTS: '/reports',
    SETTINGS: '/settings',
    ACCOUNT: '/account',
}

export const APIS = {
    AUTH: {
        LOGIN: API_URL + '/APIAuthenticate',
        LOGOUT: API_URL + '/logout',
        FORGOT_PASSWORD: API_URL + '/forgot/password',
        RESET_PASSWORD: API_URL + '/set/password',
        CHANGE_PASSWORD: API_URL + '/users/password',
        REGISTRATION: API_URL + '/register',
        AVATAR: API_URL + '/users/avatar',
    },
    USER: {
        GET_DESIGNS: API_URL + '/design/list',
        SAVE_DESIGN: API_URL + '/design/create',
        UPDATE_DESIGN: API_URL + '/design/update',
        IMAGE_LIST: API_URL + '/user-image/list',
        IMAGE_UPLOAD: API_URL + '/user-image/create',
        IMAGE_DELETE: API_URL + '/user-image/delete',
    },
    FACILITY: {
        GET_FACILITY_LIST: API_URL + '/Facility/GetFacilityList',
        GET_FACILITY_DETAILS: API_URL + '/Facility/GetFacilityByID',
        SAVE_FACILITY: API_URL + '/Facility/SaveFacility',
        DELETE_FACILITY: API_URL + '/Facility/DeleteFacility',

        GET_PROCESSING_FACILITY_LIST: API_URL + '/Facility/GetProcessingFacilities',
        GET_FACILITY_CODE: API_URL + '/Facility/GetFacilityCode',
        GET_SUB_FACILITY_LIST: API_URL + '/SubFacility/GetSubFacilityList',
        SAVE_SUB_FACILITY: API_URL + '/SubFacility/SaveSubFacility',

        GET_SUB_FACILITY_TYPE_LIST: API_URL + '/SubFacility/GetSubFacilityType',
        SAVE_FACILITY_IMAGE: API_URL + '/Facility/SaveFacilityImage',
        SAVE_SUB_FACILITY_IMAGE: API_URL + '/SubFacility/SaveSubFacilityImage',
        EXPORT_TO_CSV: API_URL + '/Facility/ExportToXLS',
        EXPORT_TO_PDF: API_URL + '/Facility/ExportToPDF',
        EXPORT_QR_CODE: API_URL + '/Facility/GetFacilityQRCodeList',


    },
    ASSETS: {
        GET_ASSETS_LIST: API_URL + '/Asset/GetAssetList',
        SAVE_ASSETS: API_URL + '/Asset/SaveAsset',
        DELETE_ASSETS: API_URL + '/Asset/DeleteAsset',
        GET_ASSET_CODE: API_URL + '/Asset/GetAssetCode',
        GET_ASSET_CATEGORY: API_URL + '/Asset/GetAssetCategoryList',
        GET_ASSET_DEPARTMENT: API_URL + '/Department/GetDepartmentList',
        GET_ASSET_GROUPLIST: API_URL + '/Asset/GetAssetGroupList',
        GET_ASSET_SUBGROUPLIST: API_URL + '/Asset/GetAssetSubGroupList',
        GET_ASSET_TYPE_LIST: API_URL + '/Asset/GetAssetTypeList',
        GET_ASSET_CLASIFICATION_LIST: API_URL + '/Asset/GetAssetClassificationList',
        GET_ASSET_STATUS_LIST: API_URL + '/Asset/GetAssetStatusList',
        GET_VENDOR_LIST: API_URL + '/Vendor/ServiceProviderList',
        UPDATE_STATUS: API_URL + '/Asset/UpdateAssetStatus',
        NOTE_LIST: API_URL + '/Asset/GetAssetNotesList',
        NOTE_SAVE: API_URL + '/Asset/SaveAssetNotes',
        DELETE_NOTES: API_URL + '/Asset/DeleteAssetNotes',

        GET_ASSET_ATTACHMENT: API_URL + '/Asset/GetAssetAttachments',
        SAVE_ASSET_ATTACHMENT: API_URL + '/Asset/SaveAssetAttachment',
        SAVE_ASSET_IMAGE: API_URL + '/Asset/SaveAssetImage',
        DELETE_ASSET_ATTACHMENT: API_URL + '/Asset/DeleteAssetAttachment',
        EXPORT_TO_CSV: API_URL + '/Asset/ExportToXLS',
        EXPORT_TO_PDF: API_URL + '/Asset/ExportToPDF',
        EXPORT_QR_CODE: API_URL + '/Asset/GetAssetQRCodeList',

    },

    COMMON: {
        GET_CITY: API_URL + '/City/GetCity',
        GET_STATE: API_URL + '/State',
        GET_COUNTY: API_URL + '/County/Get',
        GET_TEAM: API_URL + '/Teams/GetTeam',
        GET_USER: API_URL + '/User/GetUser',

        GET_SERVICE_TECH: API_URL + '/ServiceTech/GetServiceTechList',
        GET_SERVICE_PROVIDER_LIST: API_URL + '/Vendor/ServiceProviderList',
    },

    SPEAR_PARTS: {
        GET_SPEAR_PARTS_LIST: API_URL + '/SpareParts/GetPartsList',
        SAVE_SPEAR_PARTS: API_URL + '/SpareParts/SaveSparePart',
        DELETE_SPEAR_PARTS: API_URL + '/SpareParts/DeletePart',
        GET_SPEAR_PARTS_CODE: API_URL + '/SpareParts/GetPartsCode',


        GET_PARTS_ATTACHMENTS: API_URL + '/SpareParts/GetPartsAttachments',
        SAVE_PARTS_ATTACHMENTS: API_URL + '/SpareParts/SavePartsAttachment',
        SAVE_PARTS_IMAGE: API_URL + '/SpareParts/SavePartsImage',
        DELETE_PARTS_ATTACHMENTS: API_URL + '/SpareParts/DeletePartsAttachment',

        EXPORT_TO_PDF: API_URL + '/SpareParts/ExportToPDF',
        EXPORT_TO_XLS: API_URL + '/SpareParts/ExportToXLS',
        EXPORT_QR_CODE: API_URL + '/SpareParts/GetPartsQRCodeList',

        GET_PARTS_STATUS: API_URL + '/SpareParts/GetPartsStatus',
        GET_PARTS_CATEGORY_LIST: API_URL + '/SpareParts/GetPartsCategory',
        GET_PARTS_UNIT_LIST: API_URL + '/SpareParts/GetPartsUOM',

        GET_PARTS_NOTES_LIST: API_URL + '/SpareParts/GetPartsNotesList',
        SAVE_PARTS_NOTES: API_URL + '/SpareParts/SavePartsNotes',


        LOCATION_WISE_STOCK: API_URL + '/StockAdjustment/GetAdjustmentListLocationWise',
        PURCHASE_HISTORY: API_URL + '/SpareParts/PurchaseHistory', // Pending
        STOCK_PICKING_HISTORY: API_URL + '/CycleCount/StockPicking',
        STOCK_CYCLE_COUNT_HISTORY: API_URL + '/CycleCount/GetCycleCountByPart',// Pending
        STOCK_ADJUSTMENT_HISTORY: API_URL + '/StockAdjustment/GetAdjustmentListByPart',
    },

    STOCK_ADJUSTMENT: {
        LIST: API_URL + '/StockAdjustment/GetAdjustmentList',
        SAVE: API_URL + '/StockAdjustment/SaveAdjustment',
        DELETE: API_URL + '/StockAdjustment/DeleteAdjustment',
        EXPORT_TO_PDF: API_URL + '/ ',
        EXPORT_TO_XLS: API_URL + '/StockAdjustment/ExportToXLS',
        EXPORT_QR_CODE: API_URL + '/ ',
        GET_ID: API_URL + '/StockAdjustment/GetStockAdjustmentCode',
        GET_BY_ID: API_URL + '/StockAdjustment/GetStockAdjustmentByID',
        MOVE_STOCK: API_URL + '/StockAdjustment/MoveStock',
    },

    CYCLE_COUNT: {
        GET_BY_ID: API_URL + '/CycleCount/GetCycleCountByID',
        GET_BY_PART_NAME: API_URL + '/CycleCount/GetCycleCountByPart',
        LIST: API_URL + '/CycleCount/GetCycleCountList',
        SAVE: API_URL + '/CycleCount/SaveInventoryCycleCount',
        DELETE: API_URL + '/CycleCount/DeleteInventoryCycleCount',
        EXPORT_TO_PDF: API_URL + '/CycleCount/ExportToPDF',
        EXPORT_TO_XLS: API_URL + '/CycleCount/ExportToXLS',
        EXPORT_QR_CODE: API_URL + '/ ',
        GET_ID: API_URL + '/CycleCount/GetCycleCountCode',
        GET_STOCK_PICKING: API_URL + '/CycleCount/GetStockPicking',
        ADD_STOCK_PICKING: API_URL + '/CycleCount/InsertStockPicking',

        STOCK_COUNT: API_URL + '/StockCount/GetCurrentStock',
       
        
    },


}

export const ACTIONS = {
    RESET_REDUCER: "ACTIONS/RESET_REDUCER",
    DIALOG: 'ACTIONS/DIALOG',
    LOADER: {
        FP_STATUS: "ACTIONS/LOADER/FP_STATUS",
    },
    MASTER: {
        STATES: "ACTIONS/MASTER/STATES",
        COUNTY: "ACTIONS/MASTER/COUNTY",
        CITY: "ACTIONS/MASTER/CITY",
        MANAGERS: "ACTIONS/MASTER/MANAGERS",
        SERVICE_TECHS: "ACTIONS/MASTER/SERVICE_TECHS",
        TEAMS: "ACTIONS/MASTER/TEAMS",
        ELECTRICITY_PROVIDERS: "ACTIONS/MASTER/ELECTRICITY_PROVIDERS",
        GAS_PROVIDERS: "ACTIONS/MASTER/GAS_PROVIDERS",
        WATER_PROVIDERS: "ACTIONS/MASTER/WATER_PROVIDERS",
        TELEPHONE_PROVIDERS: "ACTIONS/MASTER/TELEPHONE_PROVIDERS",
        ASSETS_CATEGORIES: "ACTIONS/MASTER/ASSETS_CATEGORIES",
        ASSETS_DEPARTMENTS: "ACTIONS/MASTER/ASSETS_DEPARTMENTS",
        ASSETS_GROUPS: "ACTIONS/MASTER/ASSETS_GROUPS",
        ASSETS_SUB_GROUPS: "ACTIONS/MASTER/ASSETS_SUB_GROUPS",
        ASSETS_TYPES: "ACTIONS/MASTER/ASSETS_TYPES",
        ASSETS_CLASSIFICATIONS: "ACTIONS/MASTER/ASSETS_CLASSIFICATIONS",
        ASSETS_STATUES: "ACTIONS/MASTER/ASSETS_STATUES",
    },

    USER: {
        LOGIN: "ACTIONS/USER/LOGIN",
        USER: "ACTIONS/USER/USER",
        LOGOUT: "ACTIONS/USER/LOGOUT",
        FORGET_PASSWORD: "ACTIONS/USER/FORGET_PASSWORD",
        RESET_PASSWORD: "ACTIONS/USER/RESET_PASSWORD",
        PASSWORD_RESET: "ACTIONS/USER/PASSWORD_RESET",
    },


}

export const SAGA_ACTIONS = {
    USER: {
        LOGIN: "SAGA_ACTIONS/USER/LOGIN",
        LOGOUT: "SAGA_ACTIONS/USER/LOGOUT",
        FORGET_PASSWORD: "SAGA_ACTIONS/USER/FORGET_PASSWORD",
        RESET_PASSWORD: "SAGA_ACTIONS/USER/RESET_PASSWORD",
        REGISTER: "SAGA_ACTIONS/USER/REGISTER",
        GET_DESIGNS: "SAGA_ACTIONS/USER/GET_DESIGNS",
        SAVE_DESIGN: "SAGA_ACTIONS/USER/SAVE_DESIGN",
        UPDATE_DESIGN: "SAGA_ACTIONS/USER/UPDATE_DESIGN",

        IMAGE_LIST: "SAGA_ACTIONS/USER/IMAGE_LIST",
        IMAGE_UPLOAD: "SAGA_ACTIONS/USER/IMAGE_UPLOAD",
        IMAGE_DELETE: "SAGA_ACTIONS/USER/IMAGE_DELETE",
    },
    FACILITY: {
        GET_FACILITY_LIST: "ACTIONS/FACILITY/GET_FACILITY_LIST",
        GET_FACILITY_DETAILS: "ACTIONS/FACILITY/GET_FACILITY_DETAILS",
        SAVE_FACILITY: "ACTIONS/FACILITY/SAVE_FACILITY",
        DELETE_FACILITY: "ACTIONS/FACILITY/DELETE_FACILITY",
        GET_PROCESSING_FACILITY_LIST: "ACTIONS/FACILITY/GET_PROCESSING_FACILITY_LIST",
        GET_FACILITY_CODE: "ACTIONS/FACILITY/GET_FACILITY_CODE",
        GET_SUB_FACILITY_LIST: "ACTIONS/FACILITY/GET_SUB_FACILITY_LIST",
        SAVE_SUB_FACILITY: "ACTIONS/FACILITY/SAVE_SUB_FACILITY",
        GET_SUB_FACILITY_TYPE_LIST: "ACTIONS/FACILITY/GET_SUB_FACILITY_TYPE_LIST",
        SAVE_FACILITY_IMAGE: "ACTIONS/FACILITY/SAVE_FACILITY_IMAGE",
        SAVE_SUB_FACILITY_IMAGE: "ACTIONS/FACILITY/SAVE_SUB_FACILITY_IMAGE",
        EXPORT_TO_CSV: "ACTIONS/FACILITY/EXPORT_TO_CSV",
        EXPORT_TO_PDF: "ACTIONS/FACILITY/EXPORT_TO_PDF",
        EXPORT_QR_CODE: "ACTIONS/FACILITY/EXPORT_QR_CODE",
    },

    ASSETS: {
        GET_ASSETS_LIST: "ACTIONS/ASSETS/GET_ASSETS_LIST",
        SAVE_ASSETS: "ACTIONS/ASSETS/SAVE_ASSETS",
        DELETE_ASSETS: "ACTIONS/ASSETS/DELETE_ASSETS",
        GET_ASSET_CODE: "ACTIONS/ASSETS/GET_ASSET_CODE",
        GET_ASSET_CATEGORY: "ACTIONS/ASSETS/GET_ASSET_CATEGORY",
        GET_ASSET_DEPARTMENT: "ACTIONS/ASSETS/GET_ASSET_DEPARTMENT",
        GET_ASSET_GROUPLIST: "ACTIONS/ASSETS/GET_ASSET_GROUPLIST",
        GET_ASSET_SUBGROUPLIST: "ACTIONS/ASSETS/GET_ASSET_SUBGROUPLIST",
        GET_ASSET_TYPE_LIST: "ACTIONS/ASSETS/GET_ASSET_TYPE_LIST",
        GET_ASSET_CLASIFICATION_LIST: "ACTIONS/ASSETS/GET_ASSET_CLASIFICATION_LIST",
        GET_ASSET_STATUS_LIST: "ACTIONS/ASSETS/GET_ASSET_STATUS_LIST",
        GET_VENDOR_LIST: "ACTIONS/ASSETS/GET_VENDOR_LIST",
        UPDATE_STATUS: "ACTIONS/ASSETS/UPDATE_STATUS",
        NOTE_LIST: "ACTIONS/ASSETS/NOTE_LIST",
        NOTE_SAVE: "ACTIONS/ASSETS/NOTE_SAVE",
        DELETE_NOTES: "ACTIONS/ASSETS/DELETE_NOTES",
        SAVE_ASSET_IMAGE: "ACTIONS/ASSETS/SAVE_ASSET_IMAGE",

        GET_ASSET_ATTACHMENT: "ACTIONS/ASSETS/GET_ASSET_ATTACHMENT",
        SAVE_ASSET_ATTACHMENT: "ACTIONS/ASSETS/SAVE_ASSET_ATTACHMENT",
        DELETE_ASSET_ATTACHMENT: "ACTIONS/ASSETS/DELETE_ASSET_ATTACHMENT",
        EXPORT_TO_CSV: "ACTIONS/ASSETS/EXPORT_TO_CSV",
        EXPORT_TO_PDF: "ACTIONS/ASSETS/EXPORT_TO_PDF",
        EXPORT_QR_CODE: "ACTIONS/ASSETS/EXPORT_QR_CODE",

    },

    COMMON: {
        GET_CITY: "ACTIONS/COMMON/GET_CITY",
        GET_STATE: "ACTIONS/COMMON/GET_STATE",
        GET_COUNTY: "ACTIONS/COMMON/GET_COUNTY",
        GET_TEAM: "ACTIONS/COMMON/GET_TEAM",
        GET_USER: "ACTIONS/COMMON/GET_USER",

        GET_SERVICE_TECH: "ACTIONS/COMMON/GET_SERVICE_TECH",
        GET_SERVICE_PROVIDER_LIST: "ACTIONS/COMMON/GET_SERVICE_PROVIDER_LIST",


    },

    SPEAR_PARTS: {
        GET_SPEAR_PARTS_LIST: "ACTIONS/SPEAR_PARTS/GET_SPEAR_PARTS_LIST",
        SAVE_SPEAR_PARTS: "ACTIONS/SPEAR_PARTS/SAVE_SPEAR_PARTS",
        DELETE_SPEAR_PARTS: "ACTIONS/SPEAR_PARTS/DELETE_SPEAR_PARTS",
        GET_PARTS_ATTACHMENTS: "ACTIONS/SPEAR_PARTS/GET_PARTS_ATTACHMENTS",
        SAVE_PARTS_ATTACHMENTS: "ACTIONS/SPEAR_PARTS/SAVE_PARTS_ATTACHMENTS",
        DELETE_PARTS_ATTACHMENTS: "ACTIONS/SPEAR_PARTS/DELETE_PARTS_ATTACHMENTS",
        GET_SPEAR_PARTS_CODE: "ACTIONS/SPEAR_PARTS/GET_SPEAR_PARTS_CODE",

        SAVE_PARTS_IMAGE: "ACTIONS/SPEAR_PARTS/SAVE_PARTS_IMAGE",
        GET_PARTS_STATUS: "ACTIONS/SPEAR_PARTS/GET_PARTS_STATUS",
        GET_PARTS_CATEGORY_LIST: "ACTIONS/SPEAR_PARTS/GET_PARTS_CATEGORY_LIST",
        GET_PARTS_UNIT_LIST: "ACTIONS/SPEAR_PARTS/GET_PARTS_UNIT_LIST",

        EXPORT_TO_PDF: "ACTIONS/SPEAR_PARTS/EXPORT_TO_PDF",
        EXPORT_TO_XLS: "ACTIONS/SPEAR_PARTS/EXPORT_TO_XLS",
        EXPORT_QR_CODE: "ACTIONS/SPEAR_PARTS/EXPORT_QR_CODE",

        GET_PARTS_NOTES_LIST: "ACTIONS/SPEAR_PARTS/GET_PARTS_NOTES_LIST",
        SAVE_PARTS_NOTES: "ACTIONS/SPEAR_PARTS/SAVE_PARTS_NOTES",

        LOCATION_WISE_STOCK: "ACTIONS/SPEAR_PARTS/LOCATION_WISE_STOCK",
        PURCHASE_HISTORY: "ACTIONS/SPEAR_PARTS/PURCHASE_HISTORY",
        STOCK_PICKING_HISTORY: "ACTIONS/SPEAR_PARTS/STOCK_PICKING_HISTORY",
        STOCK_CYCLE_COUNT_HISTORY: "ACTIONS/SPEAR_PARTS/STOCK_CYCLE_COUNT_HISTORY",
        STOCK_ADJUSTMENT_HISTORY: "ACTIONS/SPEAR_PARTS/STOCK_ADJUSTMENT_HISTORY",
    },

    STOCK_ADJUSTMENT: {
        LIST: "ACTIONS/STOCK_ADJUSTMENT/LIST",
        SAVE: "ACTIONS/STOCK_ADJUSTMENT/SAVE",
        DELETE: "ACTIONS/STOCK_ADJUSTMENT/DELETE",
        EXPORT_TO_PDF: "ACTIONS/STOCK_ADJUSTMENT/EXPORT_TO_PDF",
        EXPORT_TO_XLS: "ACTIONS/STOCK_ADJUSTMENT/EXPORT_TO_XLS",
        EXPORT_QR_CODE: "ACTIONS/STOCK_ADJUSTMENT/EXPORT_QR_CODE",
        GET_ID: "ACTIONS/STOCK_ADJUSTMENT/GET_ID",
        GET_BY_ID: "ACTIONS/STOCK_ADJUSTMENT/GET_BY_ID",
        MOVE_STOCK: "ACTIONS/STOCK_ADJUSTMENT/MOVE_STOCK",
    },
 
    CYCLE_COUNT: {
        GET_BY_ID: "ACTIONS/CYCLE_COUNT/GET_BY_ID",
        GET_BY_PART_NAME: "ACTIONS/CYCLE_COUNT/GET_BY_PART_NAME",
        LIST: "ACTIONS/CYCLE_COUNT/LIST",
        SAVE: "ACTIONS/CYCLE_COUNT/SAVE",
        DELETE: "ACTIONS/CYCLE_COUNT/DELETE",
        EXPORT_TO_PDF: "ACTIONS/CYCLE_COUNT/EXPORT_TO_PDF",
        EXPORT_TO_XLS: "ACTIONS/CYCLE_COUNT/EXPORT_TO_XLS",
        EXPORT_QR_CODE: "ACTIONS/CYCLE_COUNT/EXPORT_QR_CODE",
        GET_ID: "ACTIONS/CYCLE_COUNT/GET_ID",
        GET_STOCK_PICKING: "ACTIONS/CYCLE_COUNT/GET_STOCK_PICKING",
        ADD_STOCK_PICKING: "ACTIONS/CYCLE_COUNT/ADD_STOCK_PICKING",
        STOCK_COUNT: "ACTIONS/CYCLE_COUNT/STOCK_COUNT",
        
    }

}